import type { RouteObject } from 'react-router';

import { lazy, Suspense } from 'react';

// [TODO] import lazy
import { SideBar } from 'src/pages/supplier/SubmitApplication';
import { AuthLayout, SupplierLayouts, ProtectedLayout, PublicContractsLayout } from 'src/layouts';

import { SplashScreen } from 'src/components/LoadingScreen';

import { paths } from '../paths';

const SupplierCreatePage = lazy(() => import('src/pages/supplier/Create'));
const SupplierSignupPage = lazy(() => import('src/pages/supplier/Signup'));
const CreateSideBarPage = lazy(() => import('src/pages/supplier/Create/Sidebar'));
const SubmitApplicationPage = lazy(() => import('src/pages/supplier/SubmitApplication'));
const SuccessPage = lazy(() => import('src/pages/supplier/SubmitApplication/Success'));
const EditReportPage = lazy(() => import('src/pages/supplier/SubmitReport'));
const ViewReportPage = lazy(() => import('src/pages/supplier/ViewReport'));
const PrivacyPolicyAcknowledgementPage = lazy(
  () => import('src/pages/supplier/PrivacyPolicyAcknowledgement')
);

export const supplierRoutes: RouteObject[] = [
  // Unprotected supplier routes
  {
    path: paths.supplier.signupWithInvitation,
    element: (
      <Suspense fallback={<SplashScreen />}>
        <SupplierLayouts.SetupLayout SideBarContent={<CreateSideBarPage />}>
          <SupplierCreatePage />
        </SupplierLayouts.SetupLayout>
      </Suspense>
    ),
  },
  {
    path: paths.supplier.signup,
    element: (
      <Suspense fallback={<SplashScreen />}>
        <SupplierLayouts.SupplierSignupLayout>
          <SupplierSignupPage />
        </SupplierLayouts.SupplierSignupLayout>
      </Suspense>
    ),
  },
  {
    path: 'supplier',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <ProtectedLayout allowedRoles={['SUPPLIER', 'ADMIN']} />
      </Suspense>
    ),
    children: [
      {
        path: paths.supplier.submitApplication,
        element: (
          <SupplierLayouts.SetupLayout SideBarContent={<SideBar />}>
            <SubmitApplicationPage />
          </SupplierLayouts.SetupLayout>
        ),
      },
      {
        path: paths.supplier.privacyPolicy,
        element: (
          <SupplierLayouts.SetupLayout>
            <PrivacyPolicyAcknowledgementPage />
          </SupplierLayouts.SetupLayout>
        ),
      },
      {
        path: paths.supplier.success,
        element: (
          <AuthLayout>
            <SuccessPage />
          </AuthLayout>
        ),
      },
      {
        path: paths.supplier.editReport,
        element: (
          <SupplierLayouts.SetupLayout>
            <EditReportPage isEdit />
          </SupplierLayouts.SetupLayout>
        ),
      },
      {
        path: paths.supplier.viewReport,
        element: (
          <PublicContractsLayout>
            <ViewReportPage />
          </PublicContractsLayout>
        ),
      },
    ],
  },
];
